/* Urinary Health Chews for Cats on the oc-ph-hw-v1 page layout. The packs are the live page's own: one variant, sold
   one-time only, 1, 2 or 3 pouches added as a plain quantity. The 2 and 3 packs are priced by Shopify's automatic
   discounts "Urinary Health Chews 2-pack savings" (12.48% off each pouch at 2+) and "3-pack savings" (20.84% at 3+);
   each pouch's discount is cut down to the cent, so a pouch costs price - floor(price x rate). Checked against real
   carts in AU and US on 28 Oct 2026. No subscription, no gifts; shipping is free on every order. */
(() => {
  'use strict';
  const root = document.querySelector('[data-oc-hw-native]');
  if (!root) return;
  const cfg = JSON.parse(root.querySelector('[data-hw-config]').textContent);
  const decoder = document.createElement('textarea');
  Object.keys(cfg.strings).forEach(key => {decoder.innerHTML=cfg.strings[key];cfg.strings[key]=decoder.value;});
  const params = new URLSearchParams(location.search);
  const form = root.querySelector('[data-hw-purchase]');
  const button = form.querySelector('[data-hw-add]');
  const label = button.querySelector('[data-hw-add-label]');
  const offerRoot = root.querySelector('[data-hw-offers]');
  const status = root.querySelector('[data-hw-status]');
  const radios = [...root.querySelectorAll('[name="oc-hw-pack"]')];
  let busy = false, uncertain = false;

  const formatter = new Intl.NumberFormat('en-US', {style:'currency',currency:cfg.currency});
  const money = cents => formatter.format(cents / 100);
  const price = cfg.variant.price;
  const reference = cfg.variant.compareAt > price ? cfg.variant.compareAt : price;
  const rateFor = quantity => Number(cfg.packs[String(Math.min(quantity, 3))] || 0);
  const perPouch = quantity => price - Math.floor(price * rateFor(quantity) + 1e-7);
  root.querySelectorAll('.product-info .review-product-title + .product-price').forEach(value => {value.textContent = money(price);});
  const endpoint = suffix => cfg.root.replace(/\/$/,'') + '/cart/' + suffix;
  const cartEndpoint = cfg.root.replace(/\/$/,'') + '/cart.js';
  const selected = () => Number(radios.find(r => r.checked)?.value) || 1;
  const announce = message => { status.textContent = message; };
  const cartCount = cart => document.querySelectorAll('[data-hw-cart-count]').forEach(n => {const value=String(cart.item_count);if(n.textContent!==value)n.textContent=value;});
  // The store-wide cart drawer (snippets/oc-cart, rendered by this layout) opens with a cart we already read.
  const openCart = cart => {
    if (window.ocCart) return window.ocCart.open(cart);
    location.assign(cfg.root.replace(/\/$/,'') + '/cart');
  };
  const loadCart = async () => {
    const response = await fetch(cartEndpoint, {headers:{Accept:'application/json'},cache:'no-store'});
    if (!response.ok) throw new Error(cfg.strings.cartCheck);
    return response.json();
  };
  const post = async (path,body) => {
    const response = await fetch(endpoint(path), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || cfg.strings.error);
    return data;
  };
  function marketUrl() {
    const url = new URL(location.href);
    url.searchParams.set('view',cfg.view);
    url.searchParams.delete('country');
    return url.pathname + url.search;
  }
  const marketForm = document.getElementById('oc-hw-market');
  const mobileMenu = document.querySelector('.oc-hw-mobile-nav');
  const mobileMarket = document.querySelector('[data-hw-mobile-market]');
  const desktopMarket = document.querySelector('[data-hw-desktop-market]');
  const mobileHeader = matchMedia('(max-width: 989px)');
  const placeMarket = () => {
    const destination = mobileHeader.matches ? mobileMarket : desktopMarket;
    if (marketForm && destination && marketForm.parentElement !== destination) destination.append(marketForm);
    if (!mobileHeader.matches && mobileMenu) mobileMenu.open = false;
  };
  placeMarket();
  mobileHeader.addEventListener('change',placeMarket);
  mobileMenu?.addEventListener('keydown',event => {
    if (event.key === 'Escape' && mobileMenu.open) {
      mobileMenu.open = false;
      mobileMenu.querySelector('summary').focus();
    }
  });
  const countrySelect = marketForm?.querySelector('[data-hw-country]');
  countrySelect?.addEventListener('change', () => {
    marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
    marketForm.submit();
  });
  if (cfg.requiredCountry && cfg.country !== cfg.requiredCountry && !window.Shopify?.designMode) {
    button.disabled = true;
    if (countrySelect && [...countrySelect.options].some(o => o.value === cfg.requiredCountry)) {
      countrySelect.value = cfg.requiredCountry;
      marketForm.querySelector('[data-hw-market-return]').value = marketUrl();
      marketForm.submit();
    } else announce('This country is not available in the store.');
    return;
  }
  const pouches = n => `${n} ${n === 1 ? 'pouch' : 'pouches'}`;
  // The store's own rule for "% off" badges: round down.
  const offPercent = quantity => Math.floor((1 - perPouch(quantity) / price) * 100);
  function render() {
    radios.forEach(radio => {
      const q = Number(radio.value);
      const node = radio.closest('[data-oc-bottles]');
      node.classList.toggle('kaching-bundles__bar--selected',radio.checked);
      radio.disabled = !cfg.variant.available || busy || uncertain;
      const each = perPouch(q), amount = q * each;
      const save = Math.floor((1-each/reference)*100);
      node.querySelector('[data-hw-save]').textContent = save>0 ? `You save ${save}%` : '';
      const eachNode = node.querySelector('[data-hw-each]');
      eachNode.replaceChildren(document.createTextNode(money(each)+' '));
      const per = document.createElement('span');per.className='kaching-bundles__bar-price__unit-label';per.textContent='per pouch';eachNode.append(per);
      eachNode.setAttribute('aria-label',money(each)+' per pouch');
      node.querySelector('[data-hw-reference]').textContent=money(reference);
      // The pouch count is in the bar's title, so the subtitle is the total alone (the cat page's own wording); it keeps
      // "per pouch" on one line at 375px.
      const total=node.querySelector('[data-hw-total]');if(total)total.textContent=`Total: ${money(amount)}`;
    });
    const q=selected(),amount=q*perPouch(q);
    form.querySelector('[data-hw-variant]').value=String(cfg.variant.id);
    form.querySelector('[name="quantity"]').value=String(q);
    const renewal=root.querySelector('[data-hw-renewal]');
    if(renewal)renewal.textContent=`One-time purchase: ${money(amount)} for ${pouches(q)}. No subscription, no recurring charges. Each 150 g pouch is about a ${cfg.supplyDays}-day supply. Prices in ${cfg.currency}.`;
    root.querySelectorAll('[data-hw-gift]').forEach(tile => {
      const minimum=Number(tile.dataset.hwGift),open=q>=minimum,key=tile.dataset.hwGiftKey;
      const title=tile.querySelector('.kaching-bundles__progressive-gifts__gift__title');
      const badge=tile.querySelector('.kaching-bundles__progressive-gifts__gift__label__text:not(s)');
      tile.classList.toggle('oculabs-gift--locked',!open);
      tile.dataset.ocGiftLocked=String(!open);
      if(key==='discount'&&badge)badge.textContent=open?`${offPercent(q)}% OFF`:`UP TO ${offPercent(3)}% OFF`;
      const note=open?({shipping:'On every order',guarantee:'On your first order',discount:'On every pouch'})[key]||'':`Unlocks with ${pouches(minimum)}`;
      tile.querySelector('.oculabs-gift-note').textContent=note;
      tile.setAttribute('aria-label',`${title.textContent}${badge?', '+badge.textContent:''}. ${note}`);
    });
    button.disabled=busy||uncertain||!cfg.variant.available;
    label.textContent=busy?cfg.strings.adding:!cfg.variant.available?cfg.strings.unavailable:cfg.strings.add;
    offerRoot.style.visibility='visible';
    root.dataset.hwReady=String(!button.disabled);
  }
  radios.forEach(r => r.addEventListener('change',render));
  root.querySelectorAll('[data-hw-gift]').forEach(tile => {
    const choose=() => {if(busy||uncertain)return;const r=radios.find(x=>Number(x.value)===Number(tile.dataset.hwGift));if(r&&!r.disabled&&selected()<Number(tile.dataset.hwGift)){r.checked=true;render();}};
    tile.addEventListener('click',choose);tile.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();choose();}});
  });
  function lineProperties() {
    // _oc_range_page is what the earlier page wrote, so reports on it keep working.
    const properties={_oc_range_page:cfg.handle,_oc_urinary_page:cfg.pageVersion,_oc_market:cfg.country};
    for(const key of ['utm_source','utm_medium','utm_campaign','utm_content','utm_term']){const value=params.get(key);if(value)properties['_'+key]=value.slice(0,150);}
    if(params.get('oc_qa')==='1')properties._oc_qa=cfg.pageVersion;
    return properties;
  }
  const isPouch = line => line.variant_id === cfg.variant.id && !line.selling_plan_allocation;
  const pouchCount = cart => cart.items.filter(isPouch).reduce((sum,line)=>sum+line.quantity,0);
  form.addEventListener('submit',async event => {
    event.preventDefault();if(button.disabled||busy||uncertain)return;
    busy=true;announce('');render();
    const q=selected();
    const items=[{id:cfg.variant.id,quantity:q,properties:lineProperties()}];
    if(params.get('oc_qa')==='1')root.dataset.hwSubmitItems=JSON.stringify(items);
    let submitted=false,before=0;
    try{
      const baseline=await loadCart();
      if(baseline.currency!==cfg.currency)throw new Error('Your currency changed. Refresh the page before adding this pack.');
      before=pouchCount(baseline);
      submitted=true;
      await post('add.js',{items});
      const cart=await loadCart();
      const total=pouchCount(cart);
      if(total!==before+q)throw new Error(cfg.strings.cartCheck);
      // The pack price is Shopify's own discount on the whole cart quantity; record whether it came out as the page says.
      const lines=cart.items.filter(isPouch);
      const charged=lines.reduce((sum,line)=>sum+line.final_line_price,0);
      const expected=lines.reduce((sum,line)=>sum+line.quantity*(line.price-Math.floor(line.price*rateFor(total)+1e-7)),0);
      root.dataset.hwPriceCheck=charged===expected?'ok':`mismatch ${charged} vs ${expected}`;
      cartCount(cart);openCart(cart);announce(cfg.strings.added);
      if(window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.())window.dataLayer?.push({event:'oc_urinary_add_to_cart',page:cfg.pageVersion,pouches:q,currency:cfg.currency,qa:params.get('oc_qa')==='1'});
    }catch(error){
      // A timeout can come after Shopify accepted the items. Check the saved cart before allowing another
      // click, so a retry cannot double an order.
      let added=false;
      if(submitted){
        try{const cart=await loadCart();added=pouchCount(cart)>before;cartCount(cart);uncertain=added;}
        catch{uncertain=true;}
      }
      announce(uncertain?cfg.strings.cartCheck:error instanceof TypeError?cfg.strings.error:error.message||cfg.strings.error);
      if(uncertain||added){const link=document.createElement('a');link.href=cfg.root.replace(/\/$/,'')+'/cart';link.textContent=' View cart';status.append(link);}
    }finally{busy=false;render();}
  });
  document.querySelectorAll('[data-hw-cart]').forEach(button=>button.addEventListener('click',()=>openCart()));
  window.addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
  const loadImage=img=>{if(img?.dataset.src){img.src=img.dataset.src;if(img.dataset.srcset)img.srcset=img.dataset.srcset;delete img.dataset.src;delete img.dataset.srcset;}};
  const formula=root.querySelector('#oc-hw-formula'),feeding=root.querySelector('#oc-hw-feeding'),zoom=root.querySelector('#oc-hw-zoom');
  // Safari before iOS 15.4 has no <dialog>: hide these three pop-ups until opened and open/close them by hand there.
  [formula,feeding,zoom].forEach(d=>{if(!d||typeof d.showModal==='function')return;if(!document.getElementById('oc-dialog-fallback')){const st=document.createElement('style');st.id='oc-dialog-fallback';st.textContent='#oc-hw-formula:not([open]),#oc-hw-feeding:not([open]),#oc-hw-zoom:not([open]){display:none}#oc-hw-formula[open],#oc-hw-feeding[open],#oc-hw-zoom[open]{position:fixed;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);z-index:2147483000;margin:0;max-height:88vh;overflow:auto;box-shadow:0 0 0 100vmax rgba(11,30,57,.7)}';document.head.appendChild(st);}d.showModal=()=>d.setAttribute('open','');d.close=()=>d.removeAttribute('open');});
  const formulaArtwork=root.querySelector('.shop-main-image[data-media-id="oc-urinary-10"]')||root.querySelectorAll('.shop-main-image')[3];
  const showFormula=()=>{const img=formula.querySelector('[data-hw-formula-image]');img.src=formulaArtwork.dataset.zoomSrc||formulaArtwork.dataset.src||formulaArtwork.src;img.alt=formulaArtwork.alt;};
  root.querySelectorAll('[data-hw-open]').forEach(button=>button.addEventListener('click',()=>{const dialog=button.dataset.hwOpen==='formula'?formula:feeding;if(dialog===formula)showFormula();else dialog.querySelectorAll('img').forEach(loadImage);render();dialog.showModal();dialog.querySelector('[data-hw-close]').focus();}));
  [formula,feeding,zoom].forEach(dialog=>{dialog.querySelector('[data-hw-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});});
  root.querySelector('.shop-main-image-wrapper')?.addEventListener('click',e=>{if(e.target.closest('button,a'))return;const active=root.querySelector('.shop-main-image.active');if(!active)return;const img=zoom.querySelector('img');img.src=active.dataset.zoomSrc||active.src;img.alt=active.alt;zoom.showModal();});
  // Keep FAQ paragraphs intact and expose the existing accordion to keyboards.
  root.querySelectorAll('.faq-question').forEach(question=>{const item=question.closest('.faq-item');question.tabIndex=0;question.setAttribute('role','button');const syncExpanded=()=>{const expanded=String(item.classList.contains('active'));if(question.getAttribute('aria-expanded')!==expanded)question.setAttribute('aria-expanded',expanded);};const faqObserver=new MutationObserver(syncExpanded);faqObserver.observe(item,{attributes:true,attributeFilter:['class']});faqObserver.observe(question,{attributes:true,attributeFilter:['aria-expanded']});syncExpanded();question.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();question.click();}});});
  root.querySelectorAll('.shop-thumbnail').forEach((thumb,i)=>{thumb.tabIndex=0;thumb.setAttribute('role','button');thumb.setAttribute('aria-label',`View product image ${i+1}`);thumb.addEventListener('keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();thumb.click();}});});
  const gallerySurface=root.querySelector('.shop-main-image-wrapper');
  if(gallerySurface){
    [-1,1].forEach(direction=>{
      const arrow=document.createElement('button');arrow.type='button';
      arrow.className='oc-hw-gallery-arrow '+(direction<0?'prev':'next');
      arrow.setAttribute('aria-label',direction<0?'Previous product image':'Next product image');
      arrow.textContent=direction<0?'‹':'›';
      arrow.addEventListener('click',()=>{
        const dots=[...root.querySelectorAll('.shop-dot')];
        const index=[...root.querySelectorAll('.shop-main-image')].findIndex(img=>img.classList.contains('active'));
        dots[(index+direction+dots.length)%dots.length]?.click();
      });
      gallerySurface.append(arrow);
    });
  }
  render();
})();
